import { zip } from 'lodash'

import { DashboardHeader } from '@modules/admin/Admin.Header'
import AnalyticsSample, { validateSampleField } from '@modules/admin/analytics/Analytics.SampleFilter'
import { lineDataParserTotal } from '@modules/admin/analytics/utils'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import moment from 'moment'
import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import { Trans, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Professional from '@services/Professional'
import ExportCsv from '../shared/ExportCsv'
import Title from '../shared/Title'

class AnalyticsConsultas extends Component {
  state = {
    totalChart: undefined,
    medicalChart: undefined,
    commercialChart: undefined,
    customerSupportChart: undefined,
  }

  client = Professional.analytics

  fetchConsultasChart = (values) => {
    const filters = {
      startDate:
        values.sample.startDate && moment(values.sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: values.sample.endDate && moment(values.sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      sampleRate: values.sample.sampleRate && values.sample.sampleRate,
      apiKeys: values.companyFilter.length ? values.companyFilter.map((co) => co.api_key).join(',') : undefined,
    }

    return this.client
      .getConsultasChart(filters)
      .then((response) =>
        this.setState({
          totalChart: response.total,
          medicalChart: response.medical,
          customerSupportChart: response.customerSupport,
          commercialChart: response.commercial,
        })
      )
      .catch((e) => {
        this.setState({ totalChart: undefined, medicalChart: undefined, commercialChart: undefined })
        if (values.sample.sampleRate === 'hour')
          return window.alert(this.props.t('actualmente el rango hora solo está soportado en intervalos de 24 horas'))
        window.alert(JSON.stringify(e.message, null, 2))
      })
  }

  componentDidMount() {
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { totalChart, medicalChart, commercialChart, customerSupportChart } = this.state
    const { handleSubmit, submitting } = this.props

    return (
      <div className="analytics-container">
        <DashboardHeader title={<Trans>Consultas</Trans>} />

        <Form className="container-filters-extended" onSubmit={handleSubmit(this.fetchConsultasChart)}>
          <div className="filter-extended">
            <Field name="sample" component={AnalyticsSample} validate={validateSampleField} />
            <AccessControl role="super-admin">
              <Field name="companyFilter" multi component={SelectCompanyField} />
            </AccessControl>
            {this.props.error && (
              <span style={{ color: 'red' }} className="error">
                {this.props.error}
              </span>
            )}
          </div>
          <div className="container-apply-filters">
            <button className="apply-filters">
              <Trans>Aplicar filtros</Trans>
            </button>
          </div>
        </Form>

        <Loading isFetching={submitting} />

        {totalChart && (
          <div className="chart-container">
            <Title title={<Trans>Consultas Totales</Trans>} total={totalChart.sum}>
              <ExportCsv
                data={zip(totalChart.dates, ...totalChart.datasets.map((dataset) => dataset.data))}
                filename={'Consultas_totales.csv'}
                headers={['Fecha', ...totalChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line height={70} data={lineDataParserTotal(totalChart)} />
          </div>
        )}

        {medicalChart && (
          <div className="chart-container">
            <Title title={<Trans>Consultas médicas</Trans>} total={medicalChart.sum}>
              <ExportCsv
                data={zip(medicalChart.dates, ...medicalChart.datasets.map((dataset) => dataset.data))}
                filename={'Consultas_totales.csv'}
                headers={['Fecha', ...medicalChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParserTotal(medicalChart)} height={70} />
          </div>
        )}

        {customerSupportChart && (
          <div className="chart-container">
            <Title title={<Trans>Consultas de Atención al Cliente</Trans>}>
              <ExportCsv
                data={zip(customerSupportChart.dates, ...customerSupportChart.datasets.map((dataset) => dataset.data))}
                filename={'Consultas_de_atención_al_cliente.csv'}
                headers={['Fecha', ...customerSupportChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParserTotal(customerSupportChart)} height={70} />
          </div>
        )}

        {commercialChart && (
          <div className="chart-container">
            <Title title={<Trans>Consultas Comerciales</Trans>}>
              <ExportCsv
                data={zip(commercialChart.dates, ...commercialChart.datasets.map((dataset) => dataset.data))}
                filename={'Consultas_comerciales.csv'}
                headers={['Fecha', ...commercialChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParserTotal(commercialChart)} height={70} />
          </div>
        )}
      </div>
    )
  }
}

export default compose(
  withTranslation(),
  reduxForm({
    form: 'analytics',
    initialValues: {
      sample: {
        startDate: moment().startOf('week').toDate(),
        endDate: moment().toDate(),
        sampleRate: 'hour',
        id: 'custom',
      },
      companyFilter: [],
    },
    validate: (values) => ({ _error: validateSampleField(values.sample) }),
    destroyOnUnmount: false,
  })
)(AnalyticsConsultas)
